/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { reduxForm, SubmissionError } from 'redux-form';
import { Form, FormGroup, FormControl, ControlLabel, HelpBlock } from 'react-bootstrap';
import Helmet from 'react-helmet';

import { syncValidation } from '../../utils/registrationValidator';
import SecurityBoxLogo from '../SecurityBoxLogo';
import SecurityDefaultForm from '../SecurityDefaultForm';
import RegistrationSecurityBoxControls from './RegistrationSecurityBoxControls';

import * as registration from '../../action-creators/registration';
import * as service from '../../action-creators/services';
import * as user from '../../action-creators/user';
import { validateEmail } from '../../utils/validator';
import Checkbox from '../Checkbox';

/* eslint-disable react/jsx-props-no-spreading, no-nested-ternary */
const ChatRegistration = translate(['ui'])(
  class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        email: '',
        password: '',
        repeatPassword: '',
        firstName: '',
        antibot: '',
        lastName: '',
        middleName: '',
        phone: '',
        position: '',
        companyName: '',
        companyBranch: '',
        roles: { customer: true, supplier: true },
        propsSet: false,
        registrationSuccess: false,
        focusOut: false,
        termsOfConditions: false,
        termsOfConfidential: false
      };
      this.onSubmit = this.onSubmit.bind(this);
      this.inputProps = this.inputProps.bind(this);
      this.verifyForm = this.verifyForm.bind(this);
      this.showEmailError = this.showEmailError.bind(this);
      this.showPasswordError = this.showPasswordError.bind(this);
      this.validatePassword = this.validatePassword.bind(this);
      this.setBranch = this.setBranch.bind(this);
      this.addBranch = this.addBranch.bind(this);
      this.removeBranch = this.removeBranch.bind(this);
      this.toggleCheckbox = this.toggleCheckbox.bind(this);
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
      const {
        match: {
          params: { token }
        },
        getInviteData,
        getCurrentUser
      } = this.props;
      if (token) {
        getInviteData(token);
      }
      getCurrentUser();
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(props) {
      const { inviteInfo } = props;
      const { propsSet } = this.state;

      if (inviteInfo.get('isUploaded') && !propsSet && inviteInfo.get('token')) {
        this.setState({
          email: inviteInfo.get('email'),
          companyName: inviteInfo.get('type') === 'employee' ? inviteInfo.get('companyName') : '',
          companyBranch: inviteInfo.get('type') === 'employee' ? inviteInfo.get('companyBranch') : '',
          propsSet: true
        });
      }
    }

    componentWillUnmount() {
      const { clearInvite } = this.props;
      clearInvite();
    }

    onSubmit() {
      const {
        t,
        performRegistration,
        gaSend,
        match: {
          params: { token, tokenLink, partnerToken }
        }
      } = this.props;
      const {
        email,
        password,
        firstName,
        lastName,
        middleName,
        phone,
        position,
        companyName,
        antibot,
        roles
      } = this.state;
      gaSend({ category: 'Common', action: 'reg_open', label: email });

      return performRegistration({
        email,
        password,
        firstName,
        lastName,
        middleName,
        phone,
        position,
        companyName,
        companyBranch: '',
        token,
        tokenLink,
        partnerToken,
        // Path for redirect after login by email link
        successRedirect: '/dialogs',
        antibot,
        roles
      })
        .then(({ ok, json }) => {
          if (ok) {
            if (json.location) {
              window.location = json.location;
            } else {
              this.setState({ registrationSuccess: true });
            }
            return undefined;
          }
          return json;
        })
        .then(data => {
          if (data && data.errors) {
            if (data.errors[0].message === 'Email not allowed to proceed') {
              alert(t(data.errors[0].message));
              // document.location = 'http://goodwix.com/#1481478485405-5b2d56a2-f3c8';
            }
            throw new SubmissionError({ _error: t(data.errors[0].message) });
          }
        });
    }

    get isEmployeeInvite() {
      const { inviteInfo } = this.props;
      return (
        inviteInfo && inviteInfo.get('isUploaded') && inviteInfo.get('token') && inviteInfo.get('type') === 'employee'
      );
    }

    setBranch(value, n) {
      const { companyBranch } = this.state;
      const branches = companyBranch.split('| ');
      branches[n] = value;
      this.setState({ companyBranch: branches.join('| ') });
    }

    verifyForm() {
      const {
        email,
        password,
        repeatPassword,
        firstName,
        lastName,
        companyName,
        termsOfConfidential,
        termsOfConditions
      } = this.state;
      return (
        this.verifyEmail(email) &&
        email.trim().length > 0 &&
        password.trim().length >= 8 &&
        password.trim() === repeatPassword.trim() &&
        firstName.trim().length > 0 &&
        lastName.trim().length > 0 &&
        companyName.trim().length > 0 &&
        termsOfConfidential &&
        termsOfConditions
      );
    }

    showEmailError() {
      const { t, errors } = this.props;
      const { email } = this.state;
      if (errors && errors.size) {
        const error = errors.find(err => err.get('type') === 'email');
        if (!error) return null;
        return (
          <HelpBlock id="emailErrorMessage" style={{ color: 'red' }}>
            {t(error.get('message'))}
          </HelpBlock>
        );
      }
      if (!this.verifyEmail(email)) {
        return (
          <HelpBlock id="emailErrorMessage" style={{ color: 'red' }}>
            {t('Wrong email format')}
          </HelpBlock>
        );
      }
      return null;
    }

    toggleCheckbox(checkboxName) {
      return this.setState(prevState => ({ [checkboxName]: !prevState[checkboxName] }));
    }

    validatePassword() {
      const { password, repeatPassword } = this.state;
      return repeatPassword.length && password !== repeatPassword;
    }

    showPasswordError() {
      const { t } = this.props;
      const notValid = this.validatePassword();
      if (notValid) {
        return (
          <HelpBlock id="passwordErrorMessage" style={{ color: 'red' }}>
            {t('Passwords not match')}
          </HelpBlock>
        );
      }
      return null;
    }

    showMinLengthError() {
      const { t } = this.props;
      const { password, focusOut } = this.state;
      if (password.length > 0 && password.length < 8 && focusOut) {
        return (
          <HelpBlock id="passwordErrorMessage" style={{ color: 'red' }}>
            {t('Min length 8 symbols')}
          </HelpBlock>
        );
      }
      return null;
    }

    inputProps(field) {
      const { setRegisterErrors } = this.props;
      return {
        // eslint-disable-next-line react/destructuring-assignment
        value: this.state[field],
        onChange: e => {
          if (field === 'email' && this.showEmailError()) {
            setRegisterErrors([]);
          }
          if (field === 'email' || field === 'password' || field === 'repeatPassword') {
            return this.setState({ [field]: e.target.value.trim() });
          }
          if (e.target.value === ' ') {
            return this.setState({ [field]: '' });
          }
          return this.setState({ [field]: e.target.value.replace(/^\s+|\s(?=\s)/g, '') });
        }
      };
    }

    // eslint-disable-next-line class-methods-use-this
    verifyEmail(email) {
      if (email.length) {
        return validateEmail(email);
      }
      return true;
    }

    addBranch() {
      const { companyBranch } = this.state;
      this.setState({ companyBranch: `${companyBranch}| ` });
    }

    removeBranch(n) {
      const { companyBranch } = this.state;
      const branches = companyBranch.split('| ');
      branches.splice(n, 1);
      this.setState({ companyBranch: branches.join('| ') });
    }

    render() {
      const {
        t,
        match: {
          params: { tokenLink, partnerToken }
        }
      } = this.props;
      const {
        registrationSuccess,
        email,
        password,
        repeatPassword,
        lastName,
        firstName,
        middleName,
        companyName,
        termsOfConditions,
        termsOfConfidential
      } = this.state;

      return (
        <div className="basic-container">
          <Helmet title={t('acc_reg_title')} meta={[{ name: 'description', content: t('acc_reg_description') }]} />
          <SecurityBoxLogo />
          <SecurityDefaultForm>
            {!registrationSuccess ? (
              <div className="default-right-form" style={{ height: 755 }}>
                <Form
                  horizontal
                  style={{
                    whiteSpace: 'nowrap'
                  }}
                >
                  <div
                    style={{
                      display: 'inline-block',
                      width: 700
                    }}
                  >
                    <p style={{ marginTop: 67, marginLeft: 50, fontSize: '18px', paddingBottom: 5 }}>
                      {t('Registration')}
                    </p>
                    <FormGroup
                      controlId="email"
                      // eslint-disable-next-line no-nested-ternary
                      validationState={email.length ? (this.showEmailError() ? 'error' : 'success') : null}
                      className="form-group-reg"
                      style={{ marginBottom: 10 }}
                    >
                      <ControlLabel className="control-label-login">
                        {t('E-mail')}
                        <span style={{ color: 'red' }}>* </span>
                      </ControlLabel>
                      <FormControl
                        type="mail"
                        placeholder={t('enter email')}
                        autoComplete="off"
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        {...this.inputProps('email')}
                      />
                      {this.showEmailError()}
                    </FormGroup>
                    <FormGroup
                      controlId="password"
                      validationState={
                        password.length
                          ? this.validatePassword() || (password.length < 8 && repeatPassword.length < 8)
                            ? 'error'
                            : 'success'
                          : null
                      }
                      className="form-group-reg"
                    >
                      <ControlLabel className="control-label-login">
                        {t('Password')}
                        <span style={{ color: 'red' }}>* </span>
                      </ControlLabel>
                      <FormControl
                        type="password"
                        placeholder={t('Min length 8 symbols')}
                        autoComplete="off"
                        {...this.inputProps('password')}
                        onBlur={() => this.setState({ focusOut: true })}
                      />
                      {this.showMinLengthError()}
                    </FormGroup>
                    <FormGroup
                      controlId="passwordRepeat"
                      validationState={
                        repeatPassword.length
                          ? this.validatePassword() || (password.length < 8 && repeatPassword.length < 8)
                            ? 'error'
                            : 'success'
                          : null
                      }
                      className="form-group-reg"
                    >
                      <ControlLabel className="control-label-login">
                        {t('Password repeat')}
                        <span style={{ color: 'red' }}>* </span>
                      </ControlLabel>
                      <FormControl
                        type="password"
                        placeholder={t('Min length 8 symbols')}
                        autoComplete="off"
                        {...this.inputProps('repeatPassword')}
                      />
                      {this.showPasswordError()}
                    </FormGroup>
                    <FormGroup
                      controlId="secondName"
                      validationState={lastName.length ? 'success' : null}
                      className="form-group-reg"
                    >
                      <ControlLabel className="control-label-login">
                        {t('Last Name')}
                        <span style={{ color: 'red' }}>* </span>
                      </ControlLabel>
                      <FormControl type="text" placeholder={t('enter surname')} {...this.inputProps('lastName')} />
                    </FormGroup>
                    {/* anitbot field */}
                    <FormGroup className="form-group-reg special-antibot-input">
                      <ControlLabel className="control-label-login">
                        {t('First Name')}
                        <span style={{ color: 'red' }}>* </span>
                      </ControlLabel>
                      <FormControl
                        type="text"
                        tabIndex="-1"
                        placeholder={t('enter name')}
                        {...this.inputProps('antibot')}
                      />
                    </FormGroup>
                    <FormGroup
                      controlId="name"
                      validationState={firstName.length ? 'success' : null}
                      className="form-group-reg"
                    >
                      <ControlLabel className="control-label-login">
                        {t('First Name')}
                        <span style={{ color: 'red' }}>* </span>
                      </ControlLabel>
                      <FormControl type="text" placeholder={t('enter name')} {...this.inputProps('firstName')} />
                    </FormGroup>
                    <FormGroup
                      controlId="middleName"
                      validationState={middleName.length ? 'success' : null}
                      className="form-group-reg"
                    >
                      <ControlLabel className="control-label-login">{t('Middle Name')}</ControlLabel>
                      <FormControl type="text" placeholder={t('enter middleName')} {...this.inputProps('middleName')} />
                    </FormGroup>
                    <FormGroup
                      controlId="companyName"
                      validationState={companyName.length ? 'success' : null}
                      className="form-group-reg"
                    >
                      <ControlLabel className="control-label-login">
                        {t('Company name')}
                        <span style={{ color: 'red' }}>* </span>
                      </ControlLabel>
                      <FormControl
                        type="text"
                        placeholder={t('Enter company name')}
                        disabled={this.isEmployeeInvite}
                        {...this.inputProps('companyName')}
                      />
                    </FormGroup>
                  </div>
                  <div style={{ fontSize: '12px', marginLeft: 50, width: 307 }}>
                    <FormGroup>
                      <span style={{ color: 'red', marginLeft: 15 }}>* </span>
                      {t('Required fields')}
                    </FormGroup>
                  </div>
                  <div style={{ fontSize: '12px', width: 307, marginLeft: 65 }}>
                    <FormGroup controlId="termsOfConditions" validationState={termsOfConditions ? 'success' : null}>
                      <Checkbox set={termsOfConditions} onClick={() => this.toggleCheckbox('termsOfConditions')} />
                      <span style={{ whiteSpace: 'initial' }}>
                        {t('accept_conditions')}
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://goodwix.com/soglashenie/"
                          style={{ display: 'inline-block', marginLeft: 4 }}
                        >
                          {t('terms of condition')}
                        </a>
                      </span>
                    </FormGroup>
                    <FormGroup controlId="termsOfConfidential" validationState={termsOfConfidential ? 'success' : null}>
                      <Checkbox set={termsOfConfidential} onClick={() => this.toggleCheckbox('termsOfConfidential')} />
                      <span style={{ whiteSpace: 'initial' }}>
                        {t('accept_conditions')}
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://goodwix.com/politika-konfidentsialnosti/"
                          style={{ display: 'inline-block', marginLeft: 4 }}
                        >
                          {t('terms of confidential')}
                        </a>
                      </span>
                    </FormGroup>
                  </div>
                  <RegistrationSecurityBoxControls
                    linkText={t('Enter')}
                    action={this.onSubmit}
                    isDisabled={!this.verifyForm()}
                    submitText={t('Register')}
                    tokenLink={tokenLink}
                    partnerToken={partnerToken}
                    loginLink="/chat/login"
                  />
                </Form>
              </div>
            ) : (
              <div className="default-right-form">
                <p style={{ marginTop: 110, marginLeft: 183, fontSize: '18px', paddingBottom: 5 }}>
                  <img src="/img/ico_ok.svg" alt="" />
                </p>
                <p
                  style={{
                    textAlign: 'center',
                    width: 283,
                    fontSize: 14,
                    color: '#252b49',
                    marginLeft: 59,
                    marginTop: 24
                  }}
                >
                  {t('success_registration_text')}
                </p>
                <p
                  style={{
                    textAlign: 'center',
                    width: 283,
                    fontSize: 14,
                    color: '#252b49',
                    marginLeft: 59,
                    marginTop: 30
                  }}
                >
                  {t('please_check_your_email')}
                </p>
              </div>
            )}
          </SecurityDefaultForm>
        </div>
      );
    }
  }
);

const ChatRegistrationForm = reduxForm({
  form: 'registration',
  validate: syncValidation
})(ChatRegistration);

export default connect(
  state => ({
    inviteInfo: state.main.getIn(['invite', 'inviteInfo']),
    errors: state.main.getIn(['invite', 'errors'])
  }),
  dispatch =>
    bindActionCreators(
      {
        performRegistration: registration.performRegistration,
        getInviteData: registration.getInviteData,
        setRegisterErrors: registration.setRegisterErrors,
        gaSend: service.gaSend,
        getCurrentUser: user.getCurrentUser,
        clearInvite: registration.clearInvite
      },
      dispatch
    )
)(ChatRegistrationForm);



// WEBPACK FOOTER //
// ./components/registration/ChatRegistrationContainer.jsx